import { pick } from 'ramda';
import {
  CREATE_READER_TRANSACTION,
  PAYMENT_SUCCESS,
  PROCESS_CHARGE,
  PROCESS_WEBREADER_CHARGE,
  CREATE_WEBREADER_TRANSACTION,
  READER_TRANSACTION_FAIL,
  READER_TRANSACTION_SUCCESS,
  RESET,
} from './constants';
import { CHECKOUT } from '../sale/constants';

export const resetPayments = () => ({
  type: RESET,
});

export const checkoutSale = () => ({ type: CHECKOUT });

const preparePayloadForProcessing = pick(['payments', 'type', 'kind', 'data', 'paymentToken']);
export const processCharge = payload => ({
  type: PROCESS_CHARGE,
  payload: preparePayloadForProcessing(payload),
});

export const processWebreaderCharge = payload => ({
  type: PROCESS_WEBREADER_CHARGE,
  payload,
});

export const paymentSuccess = payload => ({
  type: PAYMENT_SUCCESS,
  payload,
});

export const createReaderTransaction = payload => ({
  type: CREATE_READER_TRANSACTION,
  payload,
});

export const createWebreaderTransaction = (payload, strategy) => ({
  type: CREATE_WEBREADER_TRANSACTION,
  payload,
  strategy,
});

export const readerTransactionSuccess = ({ chargeId }) => ({
  type: READER_TRANSACTION_SUCCESS,
  payload: { chargeId },
});

export const readerTransactionFail = error => ({
  type: READER_TRANSACTION_FAIL,
  payload: error,
});
